export default __webpack_public_path__ + "static/media/chatHeaderPin.5e3c1824.svg";